import {
  PROGRAM_INCLUDED_ITEMS,
  PROGRAM_INSTALLMENT_VALUE,
  PROGRAM_INSTALLMENTS,
  PROGRAM_MONTHS,
  PROGRAM_PIX_DISCOUNT_PERCENT,
  PROGRAM_PIX_PRICE,
  PROGRAM_PRICE,
  formatBrl
} from 'pages/WeightLossProgram/constants'
import { useState } from 'react'
import { ChevronDown } from 'lucide-react'

export const ProgramCartItem = () => {
  const [open, setOpen] = useState(true)

  return (
    <div className="px-4 py-4 sm:px-6">
      <div className="rounded-2xl border border-marketplace-300 bg-marketplace-100 p-4">
        <p className="text-sm font-semibold text-[#1A1A1A]">Programa Perda de Peso</p>
        <p className="mt-1 text-lg font-semibold text-marketplace-900">{formatBrl(PROGRAM_PRICE)}</p>
        <p className="text-xs text-[#6B6560]">
          em até {PROGRAM_INSTALLMENTS}x de {formatBrl(PROGRAM_INSTALLMENT_VALUE)} · {PROGRAM_MONTHS} meses
        </p>
        <p className="text-xs text-[#6B6560]">
          ou {PROGRAM_PIX_DISCOUNT_PERCENT}% de desconto no PIX ({formatBrl(PROGRAM_PIX_PRICE)})
        </p>

        <button
          type="button"
          onClick={() => setOpen((current) => !current)}
          className="mt-3 flex w-full items-center justify-between border-0 bg-transparent p-0 text-left text-sm font-medium text-marketplace-800">
          O que está incluso no programa
          <ChevronDown className={`size-4 transition ${open ? 'rotate-180' : ''}`} />
        </button>
        {open ? (
          <ul className="mt-3 flex flex-col gap-2">
            {PROGRAM_INCLUDED_ITEMS.map((item) => (
              <li key={item.title} className="rounded-xl bg-white px-3 py-2">
                <p className="text-sm font-medium text-[#1A1A1A]">{item.title}</p>
                <p className="text-xs text-[#6B6560]">{item.detail}</p>
              </li>
            ))}
          </ul>
        ) : null}
      </div>
    </div>
  )
}
